import { render } from "./QuestionManage.vue?vue&type=template&id=b14dc606&scoped=true"
import script from "./QuestionManage.vue?vue&type=script&lang=js"
export * from "./QuestionManage.vue?vue&type=script&lang=js"

import "./QuestionManage.vue?vue&type=style&index=0&id=b14dc606&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14dc606"]])

export default __exports__